import { Button } from '@/components/Button';
import { PlaceBadget } from '@/components/PlaceBadget';
import { MapSettings, StructureType } from '@/lib/model';
import * as React from 'react';
import './index.scss';
import { LocalMap } from './LocalMap';

export interface DetailsProps {
  collegeName: string;
  fillColor: string;
  mapSettings: MapSettings;
  onModalOpen: () => void;
  structureType: StructureType;
}

export const Details: React.FC<DetailsProps> = ({
  collegeName,
  fillColor,
  mapSettings,
  onModalOpen,
  structureType,
}) => (
  <div className="Details">
    <div className="Details__map">
      <LocalMap
        {...mapSettings}
        fillColor={fillColor}
        structureType={structureType}
      />
    </div>
    <div className="Details__container">
      <div className="Details__content">
        <span className="Details___content__title">Il tuo collegio</span>
        <PlaceBadget
          fillColor={fillColor}
          collegeName={collegeName}
          className="Details__content__badget"
        />
        <div className="Details__buttons">
          <Button className="Details__button" onClick={onModalOpen}>
            Fac simile scheda con tutti i candidati
          </Button>
          <a
            href="https://tg24.sky.it/politica/elezioni/trova-partito-per-chi-votare"
            target="_blank"
          >
            <Button className="Details__button">
              Non sai chi votare? Prova il TrovaPartito!
            </Button>
          </a>
        </div>
      </div>
    </div>
  </div>
);
